



















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ControlSettingBase, {
  SectionSetting
} from "@/models/formDesigner/formDesignerControl.model";
import { FormDesignerControlCode } from "@/enums/FormDesignerControlCode";
import BaseVue from "@/core/BaseVue";
@Component({ name: "formDesignerPreviewControl" })
export default class FormDesignerPreviewControlComponent extends BaseVue {
  @Prop() readonly section!: SectionSetting;
  @Prop() readonly value!: ControlSettingBase;

  control = this.value;

  get FormDesignerControlCodeEnum() {
    return FormDesignerControlCode;
  }
  @Watch("value", { deep: true })
  onInput(value: ControlSettingBase) {
    this.control = value;
  }
  @Watch("control", { deep: true })
  onModelChange(val: ControlSettingBase) {
    this.$emit("input", val);
  }

  get childControls() {
    let refs = this.$refs.childControls as any;
    if (!refs) return [];
    return Array.isArray(refs) ? refs : [refs];
  }

  public async isValid() {
    let isValid = await this.validateCurrentValidator();
    for (const child of this.childControls) {
      if (typeof child.isValid !== "function") continue;

      let childValid = await child.isValid();
      if (!childValid) isValid = false;
    }
    return isValid;
  }

  onChildInput(index: number, value: ControlSettingBase) {
    const section = this.control as SectionSetting;
    if (!section.controls) return;
    section.controls.splice(index, 1, value);
  }
}
